import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, class_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Json$reflection } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.fs.js";
import { LoadState$2, LoadState$2$reflection } from "../../Global.js";
import { createReducer, createAction } from "../Redux.js";

export class OperationStatusDTO extends Record {
    constructor(Operation, StatusJson) {
        super();
        this.Operation = Operation;
        this.StatusJson = StatusJson;
    }
}

export function OperationStatusDTO$reflection() {
    return record_type("Redux.Reducers.Telecom.OperationStatusDTO", [], OperationStatusDTO, () => [["Operation", string_type], ["StatusJson", Json$reflection()]]);
}

export class TelecomState extends Record {
    constructor(OperationStatuses) {
        super();
        this.OperationStatuses = OperationStatuses;
    }
}

export function TelecomState$reflection() {
    return record_type("Redux.Reducers.Telecom.TelecomState", [], TelecomState, () => [["OperationStatuses", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)]]);
}

export class TelecomAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetOperationStatuses"];
    }
}

export function TelecomAction$reflection() {
    return union_type("Redux.Reducers.Telecom.TelecomAction", [], TelecomAction, () => [[["Item", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Json$reflection()]), string_type)]]]);
}

export function setOperationStatuses(payload) {
    return createAction("TelecomReducer", new TelecomAction(0, payload));
}

export const initState = new TelecomState(new LoadState$2(0));

function innerReducer(state, action) {
    return new TelecomState(action.fields[0]);
}

export function reducer(stateOpt, action) {
    return createReducer("TelecomReducer", initState, stateOpt, action, innerReducer);
}

